<template>
  <div class="router-container">
    <!-- 领导查询特殊布局 -->
    <div v-if="isLeaderQuery" class="leader-query-container">
      <div class="leader-query-header">
        <div class="title-box">
          <h1 class="main-title">领导查询</h1>
          <div class="sub-title">数据统计与分析</div>
        </div>
      </div>
      <div class="leader-query-tabs">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" tab-position="top">
          <el-tab-pane label="门诊" name="outpatient">
            <span slot="label"><i class="el-icon-menzhen"></i> 门诊</span>
            <div class="tab-content">
              <div class="report-list-container">
                <div class="report-list">
                  <div class="report-item" v-for="report in outpatientReports" :key="report.id" @click="openReportModal(report)">
                    <div class="report-icon"><i class="el-icon-document"></i></div>
                    <div class="report-content">
                      <div class="report-name">{{ report.name }}</div>
                      <div class="report-desc">{{ report.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="库存" name="stock">
            <span slot="label"><i class="el-icon-notebook-2"></i> 库存</span>
            <div class="tab-content">
              <div class="report-list-container">
                <div class="report-list">
                  <div class="report-item" v-for="report in stockReports" :key="report.id" @click="openReportModal(report)">
                    <div class="report-icon"><i class="el-icon-document"></i></div>
                    <div class="report-content">
                      <div class="report-name">{{ report.name }}</div>
                      <div class="report-desc">{{ report.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="药房" name="pharmacy">
            <span slot="label"><i class="el-icon-first-aid-kit"></i> 药房</span>
            <div class="tab-content">
              <div class="report-list-container">
                <div class="report-list">
                  <div class="report-item" v-for="report in pharmacyReports" :key="report.id" @click="openReportModal(report)">
                    <div class="report-icon"><i class="el-icon-document"></i></div>
                    <div class="report-content">
                      <div class="report-name">{{ report.name }}</div>
                      <div class="report-desc">{{ report.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="财务" name="finance">
            <span slot="label"><i class="el-icon-money"></i> 财务</span>
            <div class="tab-content">
              <div class="report-list-container">
                <div class="report-list">
                  <div class="report-item" v-for="report in financeReports" :key="report.id" @click="openReportModal(report)">
                    <div class="report-icon"><i class="el-icon-document"></i></div>
                    <div class="report-content">
                      <div class="report-name">{{ report.name }}</div>
                      <div class="report-desc">{{ report.description }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 原有多级菜单布局 -->
    <div v-else class="multi-level-menu-container">
      <div v-if="!hasValidMenuData" class="empty-state">
        <i class="el-icon-folder-opened empty-icon"></i>
        <p class="empty-text">暂无菜单</p>
      </div>
    
      <div v-if="hasValidMenuData" class="layout-container">
        <div class="left-sidebar">
          <div class="card-area" v-if="functionAreaMenus.length > 0">
            <div class="card-container">
              <div v-for="levelTwoMenu in functionAreaMenus" :key="levelTwoMenu.id" class="function-card"
                   :class="{ 'active': currentLevelTwoId === levelTwoMenu.id }"
                   @click="handleLevelTwoMenuClick(levelTwoMenu)">
                <div class="card-icon"><i :class="levelTwoMenu.icon || 'el-icon-folder'"></i></div>
                <div class="card-title">{{ levelTwoMenu.name || levelTwoMenu.title }}</div>
              </div>
            </div>
          </div>
          <div class="tag-area" v-if="basicSettingMenus.length > 0">
            <div class="tag-container">
              <el-tag v-for="levelTwoMenu in basicSettingMenus" :key="levelTwoMenu.id" class="setting-tag"
                :type="getTagType(levelTwoMenu)" :class="{ 'active': currentLevelTwoId === levelTwoMenu.id }"
                @click="handleLevelTwoMenuClick(levelTwoMenu)">
                {{ levelTwoMenu.name || levelTwoMenu.title }}
              </el-tag>
            </div>
          </div>
          <div v-if="functionAreaMenus.length === 0 && basicSettingMenus.length === 0" class="left-empty-state">
            <i class="el-icon-document-remove empty-icon"></i>
            <p class="empty-text">暂无功能菜单</p>
          </div>
        </div>
    
        <div class="right-content">
          <div v-if="reportListMenus.length > 0" class="report-section">
            <div class="report-header">
              <h4 class="report-title">报表列表</h4>
              <el-tag type="warning" size="mini">共 {{ reportListMenus.length }} 个报表</el-tag>
            </div>
            <div class="report-list">
              <div v-for="levelTwoMenu in reportListMenus" :key="levelTwoMenu.id" class="report-item"
                   :class="{ 'active': currentLevelTwoId === levelTwoMenu.id }"
                   @click="handleLevelTwoMenuClick(levelTwoMenu)">
                <div class="report-icon"><i :class="levelTwoMenu.icon || 'el-icon-document'"></i></div>
                <div class="report-content">
                  <div class="report-name">{{ levelTwoMenu.name || levelTwoMenu.title }}</div>
                  <div class="report-desc" v-if="levelTwoMenu.description">{{ levelTwoMenu.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="currentReport ? currentReport.name : '报表详情'" :visible.sync="reportModalVisible" width="80%" top="5vh">
      <div v-if="currentReport" class="report-modal-content">
        <h3>{{ currentReport.name }} - 详细数据</h3>
        <el-table :data="currentReport.data" border stripe style="width: 100%; margin-top: 20px;">
          <el-table-column v-for="column in currentReport.columns" :key="column.prop" :prop="column.prop" :label="column.label" :width="column.width"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportModalVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportReport">导出报表</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from '@/directive/event-bus.js';

export default {
  name: 'RouterMenu',
  data() {
    return {
      currentMenuData: null,
      breadcrumbHistory: [],
      parentMenuName: '菜单',
      menuStack: [],
      currentLevelTwoId: null,
      currentLevelTwoName: '',
      isLeaderQuery: false,
      activeTab: 'outpatient',
      reportModalVisible: false,
      currentReport: null,
      outpatientReports: [
        { id: 1, name: '门诊收入统计', description: '按科室统计的门诊收入情况' },
        { id: 2, name: '门诊量统计', description: '每日门诊患者数量统计' },
        { id: 3, name: '医生工作量统计', description: '各医生门诊工作量统计' },
        { id: 4, name: '药品使用统计', description: '门诊药品使用情况统计' }
      ],
      stockReports: [
        { id: 5, name: '库存盘点报表', description: '当前库存盘点情况' },
        { id: 6, name: '库存预警报表', description: '库存低于安全库存的药品' },
        { id: 7, name: '药品入库统计', description: '药品入库情况统计' },
        { id: 8, name: '药品出库统计', description: '药品出库情况统计' }
      ],
      pharmacyReports: [
        { id: 9, name: '药房销售统计', description: '药房销售情况统计' },
        { id: 10, name: '处方审核统计', description: '处方审核情况统计' },
        { id: 11, name: '药品调拨统计', description: '药品调拨情况统计' }
      ],
      financeReports: [
        { id: 12, name: '财务报表汇总', description: '财务数据汇总报表' },
        { id: 13, name: '收入支出统计', description: '收入支出情况统计' },
        { id: 14, name: '成本分析报表', description: '成本分析统计报表' }
      ],
      tableLoading: false,
    }
  },
  computed: {
    hasValidMenuData() {
      return this.currentMenuData && this.currentMenuData.children && this.getValidChildren(this.currentMenuData).length > 0;
    },
    levelTwoMenus() {
      if (!this.currentMenuData || !this.currentMenuData.children) return [];
      return this.getValidChildren(this.currentMenuData);
    },
    functionAreaMenus() {
      return this.levelTwoMenus.filter(menu => (this.getMenuComponent(menu).toLowerCase()).includes('gn'));
    },
    basicSettingMenus() {
      return this.levelTwoMenus.filter(menu => (this.getMenuComponent(menu).toLowerCase()).includes('jc'));
    },
    reportListMenus() {
      return this.levelTwoMenus.filter(menu => (this.getMenuComponent(menu).toLowerCase()).includes('bb'));
    }
  },
  watch: {
    levelTwoMenus: {
      immediate: true,
      handler(newMenus) {
        if (newMenus && newMenus.length > 0 && !this.currentLevelTwoId) {
          const functionMenu = this.functionAreaMenus[0];
          if (functionMenu) {
            this.currentLevelTwoId = functionMenu.id;
            this.currentLevelTwoName = functionMenu.name || functionMenu.title;
          } else if (newMenus.length > 0) {
            this.currentLevelTwoId = newMenus[0].id;
            this.currentLevelTwoName = newMenus[0].name || newMenus[0].title;
          }
        }
      }
    },
  },
  created() {
    EventBus.$on('left-menu-clicked', (menuData) => {
      console.log('Router.vue 接收到左侧菜单点击:', menuData)
    })
  },
  mounted() {
    EventBus.$on('menu-data-update', this.handleMenuDataUpdate);
    this.initializeMenuData();
  },
  beforeDestroy() {
    EventBus.$off('left-menu-clicked');
    EventBus.$off('menu-data-update', this.handleMenuDataUpdate);
  },
  methods: {
    getMenuComponent(menu) {
      return menu.component || '';
    },
    getTagType(menu) {
      const name = (menu.name || menu.title || '').toLowerCase();
      if (name.includes('系统')) return 'danger';
      if (name.includes('设置')) return 'warning';
      if (name.includes('配置')) return 'success';
      return 'primary';
    },
    
    // 核心修复：只有点击具体的二级卡片，才追加面包屑
    handleLevelTwoMenuClick(menu) {
      this.currentLevelTwoId = menu.id;
      this.currentLevelTwoName = menu.name || menu.title;
      
      EventBus.$emit('add-breadcrumb', {
        title: menu.name || menu.title,
        path: menu.path || this.$route.path,
        payload: { menu: menu }
      });
      
      this.navigateTo(menu);
    },

    handleMenuDataUpdate(menuPayload) {
      if (menuPayload && menuPayload.menu) {
        this.currentMenuData = this.processMenuData(menuPayload.menu);
        this.parentMenuName = menuPayload.parentMenu?.name || '菜单';
        
        const menuName = this.currentMenuData.name || this.currentMenuData.title;
        this.isLeaderQuery = menuName == '领导查询' || menuName.includes('查询');
        
        this.resetMenuState();
        
        // ★ 移除了这里的面包屑追加，左侧目录点击不加入面包屑
        
        if (this.isLeaderQuery) {
          this.$nextTick(() => {
            this.initLeaderQueryData();
          });
        }
      }
    },
    processMenuData(menuData) {
      if (!menuData) return null;
      const processedMenu = { ...menuData, id: menuData.id || menuData.menuId, name: menuData.name || menuData.title, component: menuData.component || '' };
      if (!processedMenu.children) {
        processedMenu.children = [];
      } else {
        processedMenu.children = processedMenu.children.map(child => ({
          ...child, id: child.id || child.menuId, name: child.name || child.title, component: child.component || ''
        }));
      }
      return processedMenu;
    },
    resetMenuState() {
      this.breadcrumbHistory = [];
      this.menuStack = [];
      this.currentLevelTwoId = null;
      this.currentLevelTwoName = '';
    },
    initializeMenuData() {
      this.checkPendingMenuData();
      if (!this.currentMenuData) {
        this.tryLoadMenuFromParent();
      }
    },
    checkPendingMenuData() {
      const pendingMenuStr = sessionStorage.getItem('pendingMenuData');
      if (pendingMenuStr) {
        try {
          const pendingData = JSON.parse(pendingMenuStr);
          if (pendingData.menu) {
            this.currentMenuData = this.processMenuData(pendingData.menu);
            this.parentMenuName = pendingData.parentMenu?.name || '菜单';
            
            const menuName = this.currentMenuData.name || this.currentMenuData.title;
            this.isLeaderQuery = menuName == '领导查询' || menuName.includes('查询');
            
            this.resetMenuState();
            
            if (this.isLeaderQuery) {
              this.$nextTick(() => {
                this.initLeaderQueryData();
              });
            }
          }
          sessionStorage.removeItem('pendingMenuData');
        } catch (error) {
          sessionStorage.removeItem('pendingMenuData');
        }
      }
    },
    tryLoadMenuFromParent() {
      try {
        const parentMenuStr = sessionStorage.getItem('currentParentMenu');
        const navMenusStr = sessionStorage.getItem('navMenus');
        if (parentMenuStr && navMenusStr) {
          const parentMenu = JSON.parse(parentMenuStr);
          const navMenus = JSON.parse(navMenusStr);
          this.parentMenuName = parentMenu.name || '菜单';
          const foundMenu = navMenus.find(menu => (menu.id === parentMenu.id) || (menu.menuId === parentMenu.id));
          if (foundMenu) {
            this.currentMenuData = this.processMenuData(foundMenu);
            const menuName = this.currentMenuData.name || this.currentMenuData.title;
            this.isLeaderQuery = menuName == '领导查询' || menuName.includes('查询');
            this.resetMenuState();
            if (this.isLeaderQuery) {
              this.$nextTick(() => {
                this.initLeaderQueryData();
              });
            }
          }
        }
      } catch (error) {}
    },
    navigateTo(menu) {
      if (menu.path) {
        this.$router.push(menu.path);
      } else {
        this.$message.warning('该菜单功能正在开发中');
      }
    },
    getValidChildren(menu) {
      if (!menu.children || !Array.isArray(menu.children)) return [];
      // 过滤掉了 type === 'F' 的按钮项，避免它们作为卡片显示
      return menu.children.filter(child => child.type !== 'F').map(child => ({
        ...child, id: child.id || child.menuId, name: child.name || child.title, component: child.component || ''
      }));
    },
    initLeaderQueryData() {},
    handleTabClick(tab) {},
    openReportModal(report) {
      const mockData = {
        columns: [
          { prop: 'date', label: '日期', width: 120 },
          { prop: 'item', label: '项目', width: 150 },
          { prop: 'quantity', label: '数量', width: 100 },
          { prop: 'amount', label: '金额', width: 120 },
          { prop: 'status', label: '状态', width: 100 }
        ],
        data: [
          { date: '2023-10-01', item: '项目A', quantity: 100, amount: 5000, status: '正常' },
          { date: '2023-10-02', item: '项目B', quantity: 150, amount: 7500, status: '正常' },
          { date: '2023-10-03', item: '项目C', quantity: 80, amount: 4000, status: '正常' },
          { date: '2023-10-04', item: '项目D', quantity: 200, amount: 10000, status: '异常' },
          { date: '2023-10-05', item: '项目E', quantity: 120, amount: 6000, status: '正常' }
        ]
      };
      this.currentReport = { ...report, ...mockData };
      this.reportModalVisible = true;
    },
    exportReport() {
      this.$message({ message: '报表导出成功', type: 'success' });
      this.reportModalVisible = false;
    },
    handleSortChange(sort) {},
  }
}
</script>

<style lang="less" scoped>
.router-container { min-height: calc(100vh - 60px); background: #f5f7fa; box-sizing: border-box; overflow: hidden; }
.leader-query-container { height: calc(100vh - 120px); background: white; border-radius: 12px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); display: flex; flex-direction: column; overflow: hidden; }
.leader-query-header { padding: 24px 32px; background: linear-gradient(135deg, #00557f 0%, #2596ff 100%); color: white; text-align: center; .title-box { .main-title { margin: 0; font-size: 18px; font-weight: 600; margin-bottom: 8px; } .sub-title { font-size: 12px; opacity: 0.9; } } }
/deep/ .el-tabs__header{ padding: 20px; }
/deep/ .el-tabs__item{ height: 60px; line-height: 60px; }
.leader-query-tabs { flex: 1; display: flex; flex-direction: column; overflow: hidden; :deep(.el-tabs) { flex: 1; display: flex; flex-direction: column; .el-tabs__content { flex: 1; overflow: auto; padding: 0; } .el-tab-pane { height: 100%; display: flex; align-items: center; justify-content: center; } } }
.tab-content { width: 100%; height: 100%; display: flex; justify-content: center; }
.report-list-container { width: 100%; max-width: 900px; display: flex; flex-direction: column; align-items: center; }
.report-list { grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 16px; width: 100%; display: flex; flex-direction: column; align-items: center; }
.report-item { display: flex; align-items: center; padding: 16px; background-color: #f8f9fa; border-radius: 8px; cursor: pointer; width: 180px; transition: all 0.3s; border: 1px solid #e8e8e8; &:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); border-color: #409eff; } }
.report-icon { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #409eff, #66b1ff); border-radius: 8px; margin-right: 12px; color: white; font-size: 20px; }
.report-content { flex: 1; }
.report-name { font-size: 16px; font-weight: 600; color: #304156; margin-bottom: 4px; }
.report-desc { font-size: 14px; color: #909399; }
.report-modal-content { padding: 10px; h3 { margin-bottom: 20px; color: #304156; text-align: center; } }
/deep/ .el-tabs{ text-align: center; display: flex; justify-content: center; }
.multi-level-menu-container { height: 100%; .empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; background: white; border-radius: 8px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); height: calc(100vh - 100px); .empty-icon { font-size: 72px; margin-bottom: 24px; color: #c0c4cc; } .empty-text { margin: 0; font-size: 18px; color: #909399; } } }
.layout-container { display: flex; height: calc(100vh - 140px); background: white; border-radius: 12px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); overflow: hidden; }
.left-sidebar { width: 86%; height: 100%; display: flex; flex-direction: column; background: white; border-right: 1px solid #e8e8e8; overflow: hidden; border-radius: 12px; }
.card-area { height: 90%; display: flex; justify-content: center; align-items: center; box-sizing: border-box; overflow-y: auto; }
.card-container { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; max-width: 460px; width: 100%; }
.function-card { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100px; background: linear-gradient(135deg, #ecf5ff, #d9ecff); border-radius: 8px; border: 1px solid #b3d8ff; cursor: pointer; transition: all 0.3s ease; text-align: center; padding: 16px; box-sizing: border-box; &:hover { border-color: #409eff; box-shadow: 0 6px 16px rgba(64, 158, 255, 0.2); transform: translateY(-5px); } &.active { border-color: #409eff; background: linear-gradient(135deg, #d9ecff, #ecf5ff); box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3); } .card-icon { width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; background: #409eff; border-radius: 50%; margin-bottom: 12px; i { font-size: 24px; color: white; } } .card-title { font-size: 12px; font-weight: 600; color: #409eff; } }
/deep/ .el-tag { background: #4781c3; color: #f0f9ff; border: none; }
/deep/ .el-tag:hover { background: #f0f9ff; color: #4781c3; }
.tag-area { height: 10%; display: flex; align-items: center; border-top: 1px solid #e6e6e6; background: #4781c3; padding: 0 20px; }
.tag-container { display: flex; gap: 16px; flex-wrap: wrap; justify-content: center; }
.setting-tag { cursor: pointer; font-size: 12px; transition: all 0.3s ease; &:hover { transform: scale(1.05); } &.active { background: #409eff; color: white; } }
/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{ color: #f7f7f7; }
.left-empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; color: #eeeeee; .empty-icon { font-size: 64px; margin-bottom: 16px; color: #c0c4cc; } .empty-text { margin: 0; font-size: 16px; } }
.right-content { width: 14%; height: 100%; background: #f8f9fa; overflow: hidden; display: flex; flex-direction: column; }
.report-section { flex: 1; display: flex; flex-direction: column; overflow: hidden; }
/deep/ .el-tabs__nav-wrap { display: flex; justify-content: center; }
.report-header { display: flex; flex-direction: column; justify-content: space-between; padding: 16px 20px; background: white; border-bottom: 1px solid #e8e8e8; flex-shrink: 0; .report-title { margin: 0; font-size: 16px; font-weight: 600; color: #304156; } }
.report-list { flex: 1; overflow-y: auto; padding: 10px 0; }
.report-item { display: flex; align-items: center; padding: 8px; cursor: pointer; transition: all 0.3s ease; border-bottom: 1px solid #f5f5f5; background: white; &:hover { background: #f0f9ff; transform: translateX(4px); } &.active { background: #ecf5ff; border-left: 3px solid #409eff; } &:last-child { border-bottom: none; } .report-icon { width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #ff6021, #ce3d11); border-radius: 8px; margin-right: 12px; flex-shrink: 0; i { font-size: 18px; color: white; } } .report-content { flex: 1; min-width: 0; .report-name { font-size: 12px; font-weight: 600; color: #304156; margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } .report-desc { font-size: 12px; color: #909399; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } } .report-arrow { color: #c0c4cc; transition: all 0.3s ease; font-size: 14px; flex-shrink: 0; margin-left: 12px; } &:hover .report-arrow { color: #409eff; transform: translateX(2px); } }
.right-empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; padding: 60px 20px; color: #909399; .empty-icon { font-size: 64px; margin-bottom: 20px; color: #c0c4cc; } .empty-text { margin: 0; font-size: 16px; } }
@media (max-width: 1200px) { .card-container { grid-template-columns: repeat(3, 1fr); gap: 16px; } .function-card { height: 110px; padding: 14px; .card-icon { width: 45px; height: 45px; margin-bottom: 10px; i { font-size: 22px; } } .card-title { font-size: 13px; } } .leader-query-header { padding: 16px; .main-title { font-size: 18px; } } .report-list { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 992px) { .layout-container { flex-direction: column; height: auto; } .left-sidebar { width: 100%; height: auto; border-right: none; border-bottom: 1px solid #e8e8e8; } .card-area { height: 500px; } .tag-area { height: 80px; } .right-content { width: 100%; height: 400px; } .card-container { grid-template-columns: repeat(4, 1fr); } .leader-query-container { height: auto; min-height: calc(100vh - 100px); } .report-list { grid-template-columns: 1fr; } }
@media (max-width: 768px) { .router-container { padding: 12px; } .card-container { grid-template-columns: repeat(3, 1fr); gap: 12px; } .function-card { height: 100px; padding: 12px; .card-icon { width: 40px; height: 40px; margin-bottom: 8px; i { font-size: 20px; } } .card-title { font-size: 12px; } } .tag-container { gap: 8px; } .setting-tag { padding: 6px 12px; font-size: 12px; } .leader-query-header { padding: 16px 20px; .main-title { font-size: 20px; } } }
@media (max-width: 480px) { .card-container { grid-template-columns: repeat(2, 1fr); } .function-card { height: 90px; .card-icon { width: 36px; height: 36px; margin-bottom: 6px; i { font-size: 18px; } } .card-title { font-size: 11px; } } .tag-container { justify-content: flex-start; overflow-x: auto; padding: 0 10px; } .setting-tag { flex-shrink: 0; } .report-item { padding: 10px 16px; .report-icon { width: 32px; height: 32px; margin-right: 10px; i { font-size: 16px; } } .report-name { font-size: 13px; } .report-desc { font-size: 11px; } } .leader-query-header { padding: 12px 16px; .main-title { font-size: 18px; } .sub-title { font-size: 12px; } } }
</style>